
import Vue from "vue";

import ActivitiesMixin from "@/components/ActivitiesView/ActivitiesMixin.vue";
import RoofStructureActivitiesTimelineItem from "./RoofStructureActivitiesTimelineItem.vue";

interface IRoofStructureActivitiesData {
  error: string;
  message: string;
}

export default Vue.extend({
  name: "RoofStructureActivitiesView",
  components: { RoofStructureActivitiesTimelineItem },
  mixins: [ActivitiesMixin],

  data(): IRoofStructureActivitiesData {
    return {
      error: "",
      message: ""
    };
  },
  computed: {
    queryOverride(): any {
      return {
        name__in: `
          ADD_ROOF_STRUCTURE_SUCCESS,
          ADD_ROOF_STRUCTURE_FAILURE,
          UPDATE_ROOF_STRUCTURE_SUCCESS,
          UPDATE_ROOF_STRUCTURE_FAILURE,
          DELETE_ROOF_STRUCTURE_SUCCESS,
          DELETE_ROOF_STRUCTURE_FAILURE,
          BULK_DELETE_ROOF_STRUCTURE_SUCCESS,
          BULK_DELETE_ROOF_STRUCTURE_FAILURE,
          BULK_RESTORE_ROOF_STRUCTURE_SUCCESS,
          BULK_RESTORE_ROOF_STRUCTURE_FAILURE
          `.replace(/\s/g, ""),
        activityType: "RoofStructureActivity"
      };
    }
  }
});
